import React, { Fragment } from 'react'
import { useLayout, LayoutProps } from './useLayout'
import Header from './Header/Header'
import Footer from './Footer/Footer'

const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {
  const { isLoading, children } = useLayout(props)

  return (
    <Fragment>
      <Header isLoading={isLoading} />
      {children}
      <Footer />
    </Fragment>
  )
}

export default Layout
